import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Container, Row } from 'react-bootstrap';
import './Blogs.css';
import Blog from './Blog';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        fetch('https://gentle-tor-99938.herokuapp.com/blogs')
            .then(res => res.json())
            .then((data) => setBlogs(data))
            .finally(() => setIsLoading(false));
    }, [])


    return (
        <div>
            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :
                    <div>
                        <Header></Header>
                        <Container className="my-5 pb-5">
                            <Row xs={1} md={2} className="g-4 pb-5">
                                {
                                    blogs.map(blog => <Blog
                                        blog={blog}
                                        key={blog._id}
                                    />)
                                }
                            </Row>
                        </Container>
                        <Footer></Footer>
                    </div>
            }
        </div>
    );
};

export default Blogs;